/**
 * Block deprecation
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-deprecation/
 * @see https://developer.wordpress.org/news/2023/03/block-deprecation-a-tutorial/
 */

import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import { filterOutWhiteSpace } from '../utils/general-utils';

const v2 = {
  attributes: {
    layout: {
      default: 'is-left-aligned',
      type: 'string'
    },
    horizontalRule: {
      default: false,
      type: 'boolean'
    }
  },
  supports: {
    anchor: true,
    html: false
  },
  save({ attributes }) {
    const {
      layout,
      horizontalRule
    } = attributes;

    const blockProps = useBlockProps.save({
      className: `block__carousel`
    });

    const innerBlocksClasses = filterOutWhiteSpace(
      [
        'inner-blocks-wrapper relative',
        layout
      ]
    );

    const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
      className: innerBlocksClasses
    });

    return (
      <>
        <div { ...blockProps }>
          <div className='carousel--inner'>
            <div { ...innerBlocksProps }>
              { children }
            </div>
          </div>
          { horizontalRule && (
            <hr style={ { border: '1px solid' } } />
          ) }
        </div>
      </>
    );
  }
};

const v1 = {
  attributes: {
    layout: {
      default: 'is-left-aligned',
      type: 'string'
    },
    horizontalRule: {
      default: false,
      type: 'boolean'
    }
  },
  supports: {
    anchor: true,
    html: false
  },
  save({ attributes }) {
    const {
      layout,
      horizontalRule
    } = attributes;

    const blockProps = useBlockProps.save({
      className: `block__carousel py-40 md:py-60`
    });

    const innerBlocksClasses = filterOutWhiteSpace(
      [
        'inner-blocks-wrapper relative',
        layout
      ]
    );

    const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
      className: innerBlocksClasses
    });

    return (
      <>
        <div { ...blockProps }>
          <div className='carousel--inner'>
            <div { ...innerBlocksProps }>
              { children }
            </div>
          </div>
        </div>
        { horizontalRule && (
          <hr style={ { border: '1px solid' } } />
        ) }
      </>
    );
  }
};

export default [ v2, v1 ];
